import type { MyGroupEntry, UserPublic, UserRole } from '@pta/types';
import { apiCall } from './client';

/**
 * GET /me — bejelentkezett user + role-jai.
 * 401-re a hívó (AuthProvider) `null`-t kap, és a FE redirektálhat /login-ra.
 */
export interface MeResponse {
  user: UserPublic;
  roles: UserRole[];
}

export async function fetchMe(signal?: AbortSignal): Promise<MeResponse | null> {
  try {
    return await apiCall<MeResponse>('/me', { signal });
  } catch (err) {
    if (err && typeof err === 'object' && 'status' in err && (err as { status: number }).status === 401) {
      return null;
    }
    throw err;
  }
}

/**
 * GET /me/groups — a user csoportjai (financial / leader / admin scope-ok alapján).
 * 401-nél üres lista (a /me amúgy is null-t adott vissza, ez csak biztonság).
 */
export async function fetchMyGroups(signal?: AbortSignal): Promise<MyGroupEntry[]> {
  try {
    return await apiCall<MyGroupEntry[]>('/me/groups', { signal });
  } catch (err) {
    if (err && typeof err === 'object' && 'status' in err && (err as { status: number }).status === 401) {
      return [];
    }
    throw err;
  }
}
